import React, { useEffect, useRef, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/swiper-bundle.css'
import {
  EffectCoverflow,
  Pagination,
  Keyboard,
  Mousewheel
} from 'swiper/modules'
import next from '../../assets/img/icon/next.png'
import prev from '../../assets/img/icon/prev.png'

const slideData = [
  {
    id: 1,
    title: 'Дэвшилтэт технологи',
    description:
      'Бид эсийн банк, эсийн эмчилгээнд хамгийн сүүлийн үеийн дэвшилтэт технологийг ашигладаг.',
    image: require('../../assets/img/adv/adv_1.png'),
    back: require('../../assets/img/adv/adv_b.png')
  },
  {
    id: 2,
    title: 'GMP стандартын лаборатори',
    description:
      'Манай эмнэлэг олон улсын GMP стандартыг хангасан лабораторид эсийн боловсруулалтыг хийдэг.',
    image: require('../../assets/img/adv/adv_2.png'),
    back: require('../../assets/img/adv/adv_b2.png')
  },
  {
    id: 3,
    title: 'Туршлагатай мэргэжилтнүүд',
    description:
      'Манай эмч, судлаачид эсийн боловсруулалт, хадгалалт, эмчилгээний чиглэлээр арвин туршлагатай.',
    image: require('../../assets/img/adv/adv_3.png'),
    back: require('../../assets/img/adv/adv_b3.png')
  },
  {
    id: 4,
    title: 'Үйлчлүүлэгчид тохирох шийдэл',
    description:
      'Бид таны эрүүл мэндийн хэрэгцээнд тохирсон, хувь хүнд чиглэсэн эмчилгээний төлөвлөгөөг боловсруулдаг.',
    image: require('../../assets/img/adv/adv_4.png'),
    back: require('../../assets/img/adv/adv_b4.png')
  },
  {
    id: 5,
    title: 'Ирээдүйн баталгаа',
    description:
      'Хүйн цус, эд хадгалах үйлчилгээ нь таны гэр бүлийн эрүүл мэндийн ирээдүйн баталгаа болно.',
    image: require('../../assets/img/adv/adv_5.png'),
    back: require('../../assets/img/adv/adv_b5.png')
  },
  {
    id: 6,
    title: 'Нөхөн төлжилт',
    description:
      'Эсийн эмчилгээ нь эд, эрхтэн, арьсны нөхөн төлжилтийг дэмжих шилдэг шийдэл.',
    image: require('../../assets/img/adv/adv_6.png'),
    back: require('../../assets/img/adv/adv_b6.png')
  },
  {
    id: 7,
    title: 'Үйлчилгээний  өргөн сонголт',
    description:
      'Бид эсийн банк, олон төрлийн эсийн эмчилгээ, хорт хавдрын эрсдэл тодорхойлох зэрэг олон төрлийн эмчилгээ, оношилгоог санал болгодог.',
    image: require('../../assets/img/adv/adv_7.png'),
    back: require('../../assets/img/adv/adv_b7.png')
  },
  {
    id: 8,
    title: 'Итгэлцэл, сэтгэл ханамж',
    description:
      'Манай үйлчлүүлэгчдийн сэтгэл ханамж, эрүүл мэндийн үр дүн бидний амжилтын баталгаа юм.',
    image: require('../../assets/img/adv/adv_8.png'),
    back: require('../../assets/img/adv/adv_b8.png')
  }
]

const SwiperSlider = () => {
  const swiperRef = useRef(null)
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768)
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  // const [setFocusedSlide] = useState(null)

  // const handleFocus = index => setFocusedSlide(index)
  // const handleBlur = () => setFocusedSlide(null)
  const handleClick = index => {
    if (index === 8) {
      swiperRef.current.swiper.slideTo(index + 1)
    } else {
      swiperRef.current.swiper.slideTo(index)
    }
  }
  return (
    <div className='relative flex flex-row justify-center'>
      <button onClick={() => swiperRef.current?.swiper.slidePrev()} className='w-10 ml-[-30px] mr-2 hidden mobile:flex mobile:justify-center mobile:items-center'>
        <img src={prev} alt='Arrow Down' className='h-8 w-8' />
      </button>
      <Swiper
        ref={swiperRef}
        effect='coverflow'
        grabCursor={true}
        centeredSlides={true}
        // slidesPerView={2}
        coverflowEffect={{
          rotate: 0,
          stretch: 0,
          depth: 100,
          modifier: 2,
          slideShadows: true
        }}
        loop={true}
        initialSlide={0}
        pagination={{ el: '.swiper-pagination', clickable: true }}
        breakpoints={{
          640: { slidesPerView: 1 },
          768: { slidesPerView: 2 },
          1560: { slidesPerView: 2 }
        }}
        modules={[EffectCoverflow, Pagination, Keyboard, Mousewheel]}
        autoplay={{
          delay: 1000,
          disableOnInteraction: false
        }}
      >
        {slideData.map((slide, index) => (
          <SwiperSlide
            key={slide.id}
            tabIndex={index}
            // onFocus={() => handleFocus(index)}
            // onBlur={handleBlur}
            onClick={() => handleClick(slide.id)}
            // className='h-[480px] extraScreen:h-[680px] maxScreen:h-[680px]'
            style={{
              backgroundImage: `url(${slide.back})`,
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center center',
              // border: '1px solid #CED2E8',
              borderRadius: 24,
              height: isMobile ? 400 : 580,
              width: 400
            }}
          >
            <div
              className='flex flex-col justify-center items-center p-2 extraScreen:p-5 maxScreen:p-5 h-full bg-white rounded-3xl mobile:p-0'
              style={{ border: '1px solid #CED2E8' }}
            >
              <div className='h-[236px] flex flex-col justify-center items-center extraScreen:h-[280px] extraScreen:mt-20 mobile:h-[160px] mobile:ml-4'>
                <img
                  src={slide.image}
                  alt={slide.title}
                  className='mt-5 ml-[0px] extraScreen:ml-[30px] extraScreen:mt-20 maxScreen:mt-20 mobile:ml-[-5px]'
                />
              </div>
              <div style={{ marginTop: isMobile ? 80 : 0 }}>
                <p className='text-[18px] mt-0 font-bold text-[#215998] text-center mobile:text-[14px] extraScreen:mt-5 maxScreen:mt-5'>
                  {slide.title}
                </p>
                <p className='text-center text-[16px] font-normal px-5 text-[#181B2C] mb-5 mobile:mb-0 mobile:text-[12px] mt-5'>
                  {slide.description}
                </p>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      <div className='swiper-pagination mb-[-100px]'></div>
      <button onClick={() => swiperRef.current?.swiper.slideNext()} className='w-10 mr-[-30px] ml-2 hidden mobile:flex mobile:justify-center mobile:items-center'>
        <img src={next} alt='Arrow Down' className='h-8 w-8' />
      </button>
    </div>
  )
}

export default SwiperSlider
